import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getPricePeriod } from 'pages/Home/selectors';

import {
  getFTTBSocialInternetService,
  getSocialInternetSwitcherIsDisabled,
  getSocialInternetSwitcherIsLoading,
} from 'pages/Internet/store/selectors/socialInternetSelectors';
import { switchSocialInternetCard } from 'pages/Internet/store/actions/socialInternetActions';
import {
  ServiceAdditional,
  ServiceCard,
  ServicePrice,
  ServiceSwitch,
  ServiceTitle,
} from '../../components';

export const SocialInternetCard = compose(connect(
  (state) => ({
    shouldRender: !!getFTTBSocialInternetService(state).title,
  }),
), withRenderFlag)(ServiceCard);

SocialInternetCard.Title = compose(
  connect(
    (state) => ({
      url: getFTTBSocialInternetService(state).presetUrl,
      title: getFTTBSocialInternetService(state).title,
      withLink: !!getFTTBSocialInternetService(state).presetUrl,
      shouldRender: !!getFTTBSocialInternetService(state).title,
    }),
  ),
  withRenderFlag,
)(ServiceTitle);

SocialInternetCard.Switch = connect(
  (state) => ({
    checked: getFTTBSocialInternetService(state).isChecked,
    isLoading: getSocialInternetSwitcherIsLoading(state),
    disabled: getSocialInternetSwitcherIsDisabled(state),
  }),
  {
    onChange: switchSocialInternetCard,
  },
)(ServiceSwitch);

SocialInternetCard.Additional = compose(
  connect(
    (state) => ({
      children: getFTTBSocialInternetService(state).additionalInformation,
      shouldRender: !!getFTTBSocialInternetService(state).additionalInformation,
    }),
  ),
  withRenderFlag,
)(ServiceAdditional);

SocialInternetCard.Price = connect(
  (state) => ({
    price: getFTTBSocialInternetService(state).price,
    pricePeriod: getPricePeriod(state),
  }),
)(ServicePrice);
